import { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Container,
  Box,
  CssBaseline,
  Typography,
  Backdrop,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "dayjs/locale/pt-br";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import perguntaDiariaService from "../perguntaDiariaService";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const defaultTheme = createTheme();

export function Dashboard() {
  const { getPerguntaDiaria } = perguntaDiariaService();
  const [dataSelecionada, setDataSelecionda] = useState(dayjs());
  const [responsePerguntaDiaria, setResponsePerguntaDiaria] = useState([]);

  const loadData = async () => {
    try {
      const response = await getPerguntaDiaria(
        dayjs(dataSelecionada).format("YYYY-MM-DD")
      );
      setResponsePerguntaDiaria(response.data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  };

  const handleDateChange = (date) => {
    setDataSelecionda(date);
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container maxWidth="xl">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12} md={3}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="pt-br"
              >
                <DatePicker
                  label={"Selecione o dia"}
                  views={["day", "month", "year"]}
                  value={dataSelecionada}
                  onChange={handleDateChange}
                  sx={{ display: "flex", width: "100%" }}
                  required
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={2} sx={{ alignSelf: "center" }}>
              <Button
                variant="contained"
                color="primary"
                disabled={!dataSelecionada}
                onClick={loadData}
              >
                Ver respostas
              </Button>
            </Grid>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{ fontWeight: 700, backgroundColor: "#fafafa" }}
                      >
                        Nome
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 700, backgroundColor: "#fafafa" }}
                        align="center"
                      >
                        Atividade Física
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: 700, backgroundColor: "#fafafa" }}
                        align="center"
                      >
                        Exercicio Físico
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {responsePerguntaDiaria.map((i) => (
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {i.nome_aluno}
                        </TableCell>
                        <TableCell align="center">
                          {i.realizou_atividade_fisica === "Sim" ? (
                            <CheckCircleIcon style={{ color: "green" }} />
                          ) : (
                            <CancelIcon style={{ color: "red" }} />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {i.realizou_exercicio_fisico === "Sim" ? (
                            <CheckCircleIcon style={{ color: "green" }} />
                          ) : (
                            <CancelIcon style={{ color: "red" }} />
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
